<template>
  <v-card>
    <v-alert type="info" dense icon="fa-sms"
      >To: {{ compName }} ({{ compRegIdList }}) - {{ msgType }}</v-alert
    >
    <v-spacer></v-spacer>
    <!-- <v-alert type="info" dense
            >{{ selectedSearchName }} - {{ selectedRegId }}</v-alert
          > -->
    <v-radio-group v-model="msgType" row mandatory @change="setMsgText">
      <v-radio label="MSG" value="MSG"></v-radio>
      <v-radio label="PK" value="PK"></v-radio>
      <v-radio label="EMAIL" value="EMAIL"></v-radio>
      <v-radio label="EXIT" value="EXIT"></v-radio>
      <v-radio label="CLEAR" value="CLEAR"></v-radio>
    </v-radio-group>
    <div class="about">
      <v-textarea
        v-model="compSmsText"
        outlined
        required
        prepend-inner-icon="fa-sms"
        placeholder="Sms text"
        :rules="smsRules"
        hint="Sms text"
        counter
        clearable
        clear-icon="mdi-close-circle"
      ></v-textarea>
    </div>
    <v-alert type="info" dense dismissible>{{ compComment }}</v-alert>
    <!-- <v-checkbox
      label="Add profile link in SMS"
      color="warning"
      v-model="addProfileLink"
    ></v-checkbox> -->
    <v-row justify="center" class="pa-4">
      <v-btn color="primary" rounded @click="sendSms">
        SUBMIT
        <v-icon small right>fa-sms</v-icon>
      </v-btn>
    </v-row>
     <v-row><v-spacer></v-spacer></v-row>

    <v-alert type="success" :value="isAlertVisible" dense class="pt-4">
      {{ statusResultMsg }}
    </v-alert>
    <v-alert type="error" :value="isWarningAlertVisible" dense  class="pt-4">
      {{ statusResultMsg }}
    </v-alert>
    <v-row><v-spacer></v-spacer>.</v-row>
  </v-card>
</template>

<script>
// @ is an alias to /src
import axios from "axios";

export default {
  name: "SendSingleSms",
  props: {
    regId: String,
    ac: String,
    selectedRegIdList: String,
    selectedName: String,
    selectedMobile: String,
    smsText: String,
    comment: String,
  },
  data() {
    return {
      compRegIdList: this.selectedRegIdList,
      compName: this.selectedName,
      compMobile: this.selectedMobile,
      compSmsText: this.smsText,
      compComment: this.comment,
      smsRules: [(v) => !!v || "Text is required"],
      addProfileLink: false,
      isAlertVisible: false,
      isWarningAlertVisible: false,
      errors: [],
      statuses: [],
      statusResult: Number,
      statusResultMsg: String,
      msgType: null,
    };
  },
  created() {
    this.baseUrl = "https://pgapi.azurewebsites.net/dbapi/";
    //  this.baseUrl = "http://localhost:3000/dbapi/";
    this.isValid = false;
  },
  methods: {
    //   closeComponent() {
    //       this.$emit("closeComponent", false);
    //   },
    sendSms() {
      // var regId = this.regId;
      var msg = this.compSmsText;
      // var toRegIdList = this.compRegIdList;
      // var ac = this.ac;
      // var addProfileLink = this.addProfileLink;
      var regId = this.compRegIdList; // NB: This is the recipients regId!!
      var respType = "MSG";
      var email = ""; // NOT USED FROM HERE!
      if (this.msgType == "PK") {
        respType = "PK";
      }
      if (this.msgType == "EMAIL") {
        respType = "EMAIL";
      }

      var toSubmit = JSON.stringify({ email, respType, msg });

      const uri = this.baseUrl + "gwasmssingle/" + regId;
      console.log("uri", uri);
      console.log("toSubmit", toSubmit);
      this.postit(uri, toSubmit);
    },
    postit(uri, toSubmit) {
      const axiosConfig = {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
        },
      };
      axios
        .post(uri, toSubmit, axiosConfig)
        .then((response) => {
          this.statusResult = response.data.Result;
          this.statusResultMsg = response.data.ResultMsg;
          this.setAlert(this.statusResult);
        })
        .catch((e) => {
          this.errors.push(e);
        });
    },
    setAlert(statusResult) {
      if (statusResult === 1) {
        this.isAlertVisible = true;
        this.isWarningAlertVisible = false;
      }
      if (statusResult === 0) {
        this.isWarningAlertVisible = true;
        this.isAlertVisible = false;
      }
    },
    setMsgText() {
      if (this.msgType == "PK") {
        this.compSmsText = "--- PK fra sproc: spXcSmsSingleGwa --- ";
      }
      if (this.msgType == "MSG") {
        this.compSmsText =
          "Hei. Notification Service er slått på for deg. Du velger selv hvilke områder/bokser du ønsker varsling på i din profil (My Account). ";
      }
      if (this.msgType == "EXIT") {
        this.compSmsText = "Hei. Husk EXIT i PGBox når du har landet!";
      }
      if (this.msgType == "CLEAR") {
        this.compSmsText = "";
      }
      if (this.msgType == "EMAIL") {
        this.compSmsText = "--- EMAIL fra sproc: spXcSmsSingleGwa --- ";
      }
    },
  },
};
</script>